import moment from "moment";

export const getInitials = (name) => {
  if (typeof name !== "string" || !name.trim()) return null;

  const nameParts = name.trim().split(" ");
  if (nameParts) {
    const initials = nameParts[0][0] + nameParts[nameParts.length - 1][0];
    return initials.toUpperCase();
  } else {
    return nameParts[0][0].toUpperCase();
  }
};


export const qs = (params) => {
  if (!params || typeof params !== "object") return "";
  const queryString = new URLSearchParams(params).toString();
  return queryString ? `${queryString}` : "";
};

export const formatDate = (date, format = "DD-MM-YYYY, hh:mm A") => {
  if (!date || !moment(date).isValid()) return null;
  return moment(date).format(format);
};

export const formatePrice = (number) => {
  if (!number) return "$ 0";
  const formattedNumber = Number(Math.abs(number)).toFixed(2);
  return `$ ${formattedNumber}`
};
